module.exports = __webpack_public_path__ + "files/8a49bd01f0711688596b30a04cd62d78.png";